<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.region')"
      filterable
      clearable
      :size="size"
      class="d-block"
    >
      <el-option
        v-for="(region, index) in regions"
        :key="'regions-' + index"
        :label="region.name"
        :value="region.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    if (this.regions && this.regions.length === 0) this.updateInventory();
  },
  computed: {
    ...mapGetters({
      regions: "region/inventory",
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "region/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
  },
};
</script>
